import React, { memo } from "react";
import { bindActionCreators } from "redux";
import { IaCreators } from "../../../../../store/actions/intelligence";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import './index.css'
import { UserActions } from "../../../../../store/actions/users";

function CardsAprimoramento(props) {
    const {user} = props
  const handleRenderTypeAprimoramento = (aprimoramento) => {
    const { payload } = aprimoramento
    switch(aprimoramento.type) {
      case 'ADD_SAMPLE_INTENT':
        return (
            <div className="cards-aprimoramento">
              <div>Adicionar <strong style={{color: "#00B799"}}>"{payload.text}"</strong> à intenção <strong style={{color: "#00B799"}}>"{payload.name}"</strong></div>
            </div>
        )
      case 'ADD_INTENT':
        return (
          <div className="cards-aprimoramento">
            <div>Criar intenção <strong style={{color: "#00B799"}}>"{payload.name}"</strong> e adicionar como exemplo <strong style={{color: "#00B799"}}>"{payload.text}"</strong></div>
          </div>
        )
      case 'ADD_SAMPLE_ENTITY':
        return (
          <div className="cards-aprimoramento">
              <div>Adicionar <strong style={{color: "#ff770d"}}>"{payload.text}"</strong> à entidade <strong style={{color: "#ff770d"}}>"{payload.name}"</strong></div>
          </div>
        )
      case 'ADD_ENTITY':
        return (
          <div className="cards-aprimoramento">
            <div>Criar entidade <strong style={{color: "#ff770d"}}>"{payload.name}"</strong> e adicionar como exemplo <strong style={{color: "#ff770d"}}>"{payload.text}"</strong></div>
          </div>
        )
      default:
        return null
    }
  }



  return (
    <div>
      {props.aprimoramentos.length > 0 &&
        <div className="cards-aprimoramento-title">
          <br/><br/>Aprimoramentos:<br/>
        </div>
      }
      {props.aprimoramentos.map((aprimoramento, index) => (
        <div className="container-cards-aprimoramento" key={"aprimoramento" + index}>
          {handleRenderTypeAprimoramento(aprimoramento)}
          <div className="cards-aprimoramento-delete" onClick={user && user.selectedCompany.claim.name !== 'Viewer' ?() => props.deleteAprimoramento(aprimoramento): ''}>deletar</div>
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = (state) => ({
  aprimoramentos: state.intelligence.aprimoramentos,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
      ...UserActions,
    },
    dispatch
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(memo(CardsAprimoramento))));
